import { Box, Button, Typography, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import FooterNav from "./FooterNav";
import { setOpen, toggleOpen } from "../redux/slices/alertOpen";
import { unsetCookie } from "./Login";
import axiosInstance from "../AxiosBaseApi";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const TeamDataBox = ({ title, registration, commission, revenue }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap",
        background: "#fff",
        margin: 2,
        borderRadius: "10px",
        padding: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "30%",
        }}
      >
        <Typography variant="subtitle1">{registration}</Typography>
        <Typography variant="subtitle1">Registration validity</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "30%",
        }}
      >
        <Typography variant="subtitle1">{commission}</Typography>
        <Typography variant="subtitle1">Commission Percentage</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "30%",
        }}
      >
        <Typography variant="subtitle1">{revenue}</Typography>
        <Typography variant="subtitle1">Accumulated Revenue</Typography>
      </Box>
    </Box>
  );
};

const TeamReport = () => {
  const userInfo = useSelector((state) => state.userdata);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState("");
  const [inviteData, setInviteData] = useState([]); // State to store invite data
  const [inviteRecordData, setInviteRecordData] = useState([]); // State to store invite record data
  const [loading, setLoading] = useState(false); // State for loading indicator
  // Fetch user data from the original API
  const getUserData = async (uid) => {
    try {
      const response = await axiosInstance.get(
        `/bet.php?action=getuserinfo&user=${uid}`
      );
      if (response.status === 200) {
        setData(response.data);
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  // Fetch invite data from the new API
  const getInviteData = async (usercode) => {
    setLoading(true); // Start loading
    try {
      const response = await axiosInstance.get(
        `https://taskapi.demovt360.xyz/sst/src/api/bet.php?action=invite&usercode=${usercode}`
      );
      if (response.status === 200) {
        setInviteData(response.data); // Set invite data
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  // Fetch invite record data from the new API (new API call)
  const getInviteRecordData = async (usercode, level) => {
    setLoading(true); // Start loading
    try {
      const response = await axiosInstance.get(
        `https://taskapi.demovt360.xyz/sst/src/api/bet.php?action=inviterecord&user=${usercode}&level=${level}`
      );
      if (response.status === 200) {
        setInviteRecordData(response.data); // Set invite record data
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.log("Error", error);
    } finally {
      setLoading(false); // Stop loading after the request completes
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      navigate("/login");
    } else {
      getUserData(token);
      getInviteData(token); // Pass the user code (or uid) for the invite API
      getInviteRecordData(token, "A"); // Pass the user code and level (A, B, C)
    }
  }, []);

  const logOut = () => {
    unsetCookie();
    navigate("/login");
  };
  
  return (
    <>
      <Box sx={{ width: "100%", marginBottom: 8 }}>
        <Box
          sx={{
            height: "8vh",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#3d3b6f",
            alignItems: "center",
            padding: "0 14px",
          }}
        >
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
            <ChevronLeftIcon
              fontSize="medium"
              sx={{ border: "1px solid #f2f3f5", borderRadius: "50%" }}
            />
          </IconButton>
          <Typography
            variant="body2"
            sx={{ color: "#fff", marginLeft: "-25px" }}
          >
            Team Report
          </Typography>
          <Typography variant="body2" sx={{ color: "#fff" }}></Typography>
        </Box>

        <Box
          sx={{
            margin: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle1" sx={{ color: "#3d3b6f" }}>
            Team Data Overview
          </Typography>
          <Button sx={{ color: "#3d3b6f", fontSize: "14px" }}>all</Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            background: "#fff",
            margin: 2,
            borderRadius: "10px",
            padding: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "45%",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="subtitle1">Team Registration</Typography>
            <Typography variant="subtitle1">{inviteData[0]?.totalinvites}</Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              width: "45%",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="subtitle1">Team Commission</Typography>
            <Typography variant="subtitle1">{inviteData[0]?.totalbonus}</Typography>
          </Box>
        </Box>

        <Box
          sx={{
            margin: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle2" sx={{ color: "#3d3b6f" }}>
            Position: Assistant
          </Typography>
        </Box>

        <Box
          sx={{
            margin: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle1" sx={{ color: "#3d3b6f" }}>
            Team Data
          </Typography>
          <Button sx={{ color: "#3d3b6f", fontSize: "14px" }}>all</Button>
        </Box>

        <TeamDataBox registration={`${inviteRecordData[0]?.level1 || "No Data"}`}  commission="8%" revenue={`${inviteRecordData[0]?.tlevel1 || "0"}`}  />
        <TeamDataBox registration={`${inviteRecordData[0]?.level2 || "No Data"}`}  commission="2%" revenue={`${inviteRecordData[0]?.tlevel2 || "0"}`}/>
        <TeamDataBox registration={`${inviteRecordData[0]?.level3 || "No Data"}`}  commission="1%" revenue={`${inviteRecordData[0]?.tlevel3 || "0"}`} />

        <Box sx={{ m: 1, p: 2, bgcolor: "#fff", borderRadius: "10px" }}>
          <Typography variant="body2" color="textSecondary">
            * People who join through your invitation link are your A-level
            subordinates.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            * People who join through your invitation link are your B-level
            subordinates.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            * People who join through your invitation link are your C-level
            subordinates.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            * Any regular employee has the right to recruit people who need to
            join video task. The more people you recruit, the more recruitment rewards
            you get.
          </Typography>
        </Box>
      </Box>

      <FooterNav />
    </>
  );
};

export default TeamReport;
